import { Button, Form, Input,  Table } from "antd"
import { seachUserInfo } from "../../api"
import {  PageBuilder } from "../../utils/Page"
import { UserInfoSearchFilter,  UserInfoView } from "../../interfaces/UserInfo"
import { useEffect, useState } from "react"
import '../matchResult/index.css'

const UserInfo = () => {
    const [searchFilter, setSearchFilter] = useState<UserInfoSearchFilter>({})
    const [data, setData] = useState<UserInfoView[]>()
    const [current, setCurrent] = useState<number>(1)
    const [pageSize, setPageSize] = useState<number>(10)
    const [totalElements, setTotalElements] = useState<number>(500)
    const columns = [
        {
            title: "用户编号",
            dataIndex: "userNumber",
        },
        {
            title: "手机号",
            dataIndex: "phoneNumber"
        },
        {
            title: "姓氏",
            dataIndex: "gender",
        },
        {
            title: "编号",
            dataIndex: "identifier"
        },
        {
            title: "当前金额",
            dataIndex: "currentAmount"
        },
        {
            title: "推荐奖",
            dataIndex: "award"
        },
        {
            title: "绑定邮箱",
            dataIndex: "email"
        },
    ]

    const search = async () => {
        const page = new PageBuilder()
            .setPage(current - 1)
            .setSize(pageSize)
            .build()
        const { data } = await seachUserInfo({
            params: { ...page, searchFilterCombineOperation: "AND" },
            filters: searchFilter
        })
        setData(data.content)
        setTotalElements(data.totalElements)
    }

    const handleSearch = async (filter: UserInfoSearchFilter) => {
        setSearchFilter(filter)
    }

    const handleTableChange = (pagination: any) => {
        setCurrent(pagination.current)
        setPageSize(pagination.pageSize)
    }

    useEffect(() => { search() }, [current, pageSize, searchFilter])
    return <div>
        <div className="flex-box">
            <Form<UserInfoSearchFilter>
                layout="inline"
                onFinish={handleSearch}
            >
                <Form.Item 
                label="手机号: "
                name="phoneNumberLike">
                    <Input />
                </Form.Item>
                <Form.Item 
                label="姓氏: "
                name="gender">
                    <Input />
                </Form.Item>
                <Form.Item
                label="编号: "
                name="identifier">
                    <Input />
                </Form.Item>
                <Form.Item 
                label="邮箱: "
                name="emailLike">
                    <Input />
                </Form.Item>
                <div className="search-button">
                <Form.Item>
                    <Button htmlType="reset" type="default">重置</Button>
                </Form.Item>
                <Form.Item>
                    <Button htmlType="submit" type="primary">搜索</Button>
                </Form.Item>
                </div>
            </Form>
        </div>

        <Table<UserInfoView> rowKey={'userNumber'} columns={columns} dataSource={data}
            pagination={{
                current: current,
                total: totalElements,
                hideOnSinglePage: true
            }}
            onChange={handleTableChange}
        />
    </div>
}

export default UserInfo
